module.exports = __webpack_public_path__ + "img/bf.77f41ded.svg";